export const STATUSES = [
  { key: "criacao_cotacao", label: "Criação da Cotação", short: "Criação", color: "zinc" },
  { key: "cotacao_enviada", label: "Cotação Enviada", short: "Enviada", color: "blue" },
  { key: "encomenda_confirmada", label: "Encomenda Confirmada", short: "Confirmada", color: "emerald" },
  { key: "em_producao", label: "Em Produção", short: "Produção", color: "amber" },
  { key: "enviado", label: "Enviado", short: "Enviado", color: "sky" },
  { key: "concluido", label: "Concluído", short: "Concluído", color: "violet" },
];

export const STATUS_MAP = Object.fromEntries(STATUSES.map((s) => [s.key, s]));

export const STATUS_BADGE = {
  criacao_cotacao: "text-zinc-300 bg-zinc-900 border-zinc-700",
  cotacao_enviada: "text-blue-300 bg-blue-950/40 border-blue-900/60",
  encomenda_confirmada: "text-emerald-300 bg-emerald-950/40 border-emerald-900/60",
  em_producao: "text-amber-300 bg-amber-950/40 border-amber-900/60",
  enviado: "text-sky-300 bg-sky-950/40 border-sky-900/60",
  concluido: "text-violet-300 bg-violet-950/40 border-violet-900/60",
};

export const STATUS_DOT = {
  criacao_cotacao: "bg-zinc-400",
  cotacao_enviada: "bg-blue-400",
  encomenda_confirmada: "bg-emerald-400",
  em_producao: "bg-amber-400",
  enviado: "bg-sky-400",
  concluido: "bg-violet-400",
};
